<template>
<moo-dialog custom-class="home-check-setting-common-dialog home-check-setting-dialog" :append-to-body="true" :visible.sync="visible" width="480px" :before-close="() => handleCheckDialog(false)">
    <div class="content">
      <div class="title">{{$t("提示#!!!#src/pages/CloudHome/components/PreCheckFolderUploadDialog.vue_1")}}        <div class="close-btn" @click.stop="() => handleCheckDialog(false)">
          <svg-icon icon-class="file-transfer-close" class="close-icon"></svg-icon>
        </div>
      </div>
      <div class="tip">{{$t("当前仅支持以下文件格式：.doc、.docx、.xls、.xlsx、.ppt、.pptx、.pdf，文件夹内其他格式文件不会上传，为避免遗漏文件，请检查格式后上传。#!!!#src/pages/CloudHome/components/PreCheckFolderUploadDialog.vue_1")}}      </div>
      <div class="footer">
        <moo-button class="cancel" @click="visible = false">{{$t("取 消#!!!#src/pages/CloudHome/components/PreCheckFolderUploadDialog.vue_1")}}</moo-button>
        <moo-button class="submit" type="primary" @click="handleUpload">{{$t("上传文件夹#!!!#src/pages/CloudHome/components/PreCheckFolderUploadDialog.vue_1")}}</moo-button>
      </div>
    </div>
  </moo-dialog>
</template>

<script>
export default {
  props: {},
  name: "PreCheckFolderUploadDialog",
  components: {},
  data() {
    return {
      visible: false,
      data: "",
    };
  },
  methods: {
    handleUpload() {
      this.$emit('handlUpload');
      this.visible = false;
    },
    handleCheckDialog(value, item) {
      this.visible = value;
      if (item) {
        this.data = item;
      }
    },
  },
  computed: {},
  watch: {},
  mounted() {},
  destroyed() {},
};
</script>

<style lang="scss">
.home-check-setting-common-dialog {
  border-radius: 16px !important;
}

.home-check-setting-dialog {
    .moo-dialog__header {
        display: none !important;
    }
  .moo-dialog__body {
    padding: 0px !important;
    .content {
      display: flex;
      flex-flow: column;
      width: 100%;
      /* height: 480px; */
      box-sizing: border-box;
      background: #ffffff;
      border-radius: 16px;

      .title {
        width: 100%;
        height: 54px;
        font-family: "PingFang SC", sans-serif;
        font-weight: 600;
        font-size: 16px;
        color: #121317;
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #f1f4f5;
        padding: 0 24px;
        box-sizing: border-box;

        .close-btn {
          width: 24px;
          height: 24px;
          cursor: pointer;

          .close-icon {
            padding: 5px;
            width: 14px;
            height: 14px;
          }

          &:hover {
            background: #f4f6f9;
            border-radius: 4px;
          }
        }
      }

      .tip {
        padding: 24px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.5);
        display: flex;
        flex-flow: row;
        align-items: center;

        .folder-icon {
          width: 35px;
          height: 35px;
          margin-right: 8px;
        }
      }

      .footer {
        border-top: 1px solid #f1f4f5;
        padding: 10px 24px;
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: flex-end;

        .cancel {
          outline: none;
          padding: 0;
          color: #222329;
          background: #fff;
          border: 1px solid #e8e9ee;
          font-size: 14px;
          font-weight: 400;
          height: 30px;
          width: 100px;
          border-radius: 4px;
        }

        .submit {
          outline: none;
          color: #fff;
          background: #5c70ff;
          border: none;
          box-shadow: inset -0.5px 0.5px rgba(0, 0, 0, 0.3),
            inset 0.5px -0.5px rgba(0, 0, 0, 0.3);
          font-size: 13px;
          font-weight: 400;
          padding: 0;
          height: 30px;
          width: 100px;
          border-radius: 4px;
        }
      }
    }
  }
}
</style>
